import * as Phaser from "phaser";
import {COOK_SPRITE_ORDER, CookSpriteNames} from "../model/cooks";
import AnimationManager = Phaser.Animations.AnimationManager;
import Animation = Phaser.Animations.Animation;
import {Directions} from "../model/direction";


export function generateSpriteAllMovesAnimations(animationManager: AnimationManager, sprite_key: CookSpriteNames) {
    let anims = {string: Animation}
    anims[Directions.UP] = createMovementAnimation(animationManager, sprite_key, Directions.UP, generateSpriteMovingFrames(animationManager, sprite_key, 1)) || undefined;
    anims[Directions.DOWN] = createMovementAnimation(animationManager, sprite_key, Directions.DOWN, generateSpriteMovingFrames(animationManager, sprite_key, 0)) || undefined;
    anims[Directions.LEFT] = createMovementAnimation(animationManager, sprite_key, Directions.LEFT, generateSpriteMovingFrames(animationManager, sprite_key, 2)) || undefined;
    anims[Directions.RIGHT] = createMovementAnimation(animationManager, sprite_key, Directions.RIGHT, generateSpriteMovingFrames(animationManager, sprite_key, 3)) || undefined
    return anims
}

export function createMovementAnimation(animationManager: Phaser.Animations.AnimationManager, sprite_name: string, move: Directions, frames: Phaser.Types.Animations.AnimationFrame[]) {
    return animationManager.create({
        key: `${sprite_name}-${move}`,
        frames: frames,
        frameRate: 10,
        repeat: -1
    });
}

export function generateSpriteMovingFrames(animation_manager: AnimationManager, spriteKey, start_index) {
    return animation_manager.generateFrameNumbers(spriteKey,
        {
            frames: Array.from(Array(6).keys()).map((v, i) => i * 4+start_index)
        })
}

export function generateSpriteIdleFrames(animation_manager: AnimationManager, spriteKey: CookSpriteNames) {
    return animation_manager.generateFrameNumbers(spriteKey,
        {
            frames: [0]
            // construct a randomly activated anim
            // frames: Array.from(Array(4).keys()).map((v, i) => i + 4*6)
        })
}

export function animationKeyOf(sprite_name: CookSpriteNames, direction: Directions) {
    let animation_key: Directions
    switch (direction) {
        case Directions.UP: animation_key = Directions.UP; break
        case Directions.DOWN: animation_key = Directions.DOWN; break
        case Directions.RIGHT: animation_key = Directions.RIGHT; break
        case Directions.UPRIGHT: animation_key = Directions.RIGHT; break
        case Directions.DOWNRIGHT: animation_key = Directions.RIGHT; break
        case Directions.UPLEFT: animation_key = Directions.LEFT; break
        case Directions.DOWNLEFT: animation_key = Directions.LEFT; break
        case Directions.LEFT: animation_key = Directions.LEFT; break
    }
    return `${sprite_name}-${animation_key}`;
}

export function generateAllSpritesAnimations(animationManager: AnimationManager) {
    COOK_SPRITE_ORDER.forEach((sprite_key, index) => {
        generateSpriteAllMovesAnimations(animationManager, sprite_key);
    })
}
